import React from 'react'

export default function UiAbuDhabiVeticalChartElement(props) {

    return (
        <>
            <ol className="sb-ol-list">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>

            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li className='sb-perfomance-graph-above-perct'></li>

            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li className='sb-perfomance-graph-above-perct'></li>

            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li className='sb-perfomance-graph-above-perct sb-performance-above-target'>
                <span> {props.actualScore > '138' ? '138+%' :'130%'} </span>
            </li>

            <li></li>
            <li></li>
            <li></li>
            <li className='sb-perfomance-graph-above-perct sb-perfomance-graph-last'>
               <span>{props.actualScore >= '138' ? `${Math.trunc(props.actualScore)}%` :'138+%'} </span>             
            </li> 
            </ol>
        </>
    )
}
